import React, {
  useEffect,
  useState,
} from "react";

import {
  Stack,
  Select,
  Box,
  Text,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";


const EditContactLogDrawer = ({
  isOpen,
  onClose,
  log,
  onUpdate,
}) => {

  const [
    formData,
    setFormData,
  ] = useState({});


  useEffect(() => {

    if (log) {

      setFormData({
        ...log,

        status:
          log.status ||
          "PENDING",

        reason:
          log.reason || "",

        notes:
          log.notes || "",

        outcome:
          log.outcome || "",

        next_action:
          log.next_action || "",

        follow_up_date:
          log.follow_up_date || "",
      });

    }

  }, [log]);


  const handleChange = (
    e
  ) => {

    const {
      name,
      value,
    } = e.target;

    setFormData(
      (prev) => ({
        ...prev,
        [name]: value,
      })
    );
  };


  const handleSubmit = () => {

    onUpdate(
      formData
    );

    onClose();
  };


  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}

      headerContent={
        <h2>
          Edit Contact Log
        </h2>
      }

      bodyContent={

        <Stack spacing={4}>

          {/* STATUS */}

 <Box>
  <Text
    fontSize="sm"
    fontWeight="500"
    color="#8D93A1"
    mb={1}
  >
    Status
  </Text>

  <Select
    name="status"
    value={
      formData.status ||
      "Pending"
    }
    onChange={handleChange}
  >
    <option value="Contacted">
      Contacted
    </option>

    <option value="Not Reached">
      Not Reached
    </option>

    <option value="Pending">
      Pending
    </option>
  </Select>
</Box>

          {/* REASON */}

          <ReusableInput
            label="Reason"
            name="reason"
            value={
              formData.reason ||
              ""
            }
            onChange={
              handleChange
            }
          />


          {/* NOTES */}

          <ReusableInput
            label="Notes"
            name="notes"
            value={
              formData.notes ||
              ""
            }
            onChange={
              handleChange
            }
          />


          {/* OUTCOME */}

          <ReusableInput
            label="Outcome"
            name="outcome"
            value={
              formData.outcome ||
              ""
            }
            onChange={
              handleChange
            }
          />


          {/* NEXT ACTION */}

          <ReusableInput
            label="Next Action"
            name="next_action"
            value={
              formData.next_action ||
              ""
            }
            onChange={
              handleChange
            }
          />


          {/* FOLLOW-UP DATE */}

          <ReusableInput
            label="Follow Up Date"
            name="follow_up_date"
            type="date"
            value={
              formData.follow_up_date ||
              ""
            }
            onChange={
              handleChange
            }
          />

        </Stack>
      }


      footerContent={

        <Stack
          direction="row"
          justify="flex-end"
        >

          <GradientButton
            onClick={
              onClose
            }
            height="37px"
          >
            Cancel
          </GradientButton>


          <GradientButton
            onClick={
              handleSubmit
            }
            height="37px"
          >
            Update
          </GradientButton>

        </Stack>
      }
    />
  );
};


export default EditContactLogDrawer;